let activeOnboardingId: string | null = null;

export function requestOnboarding(id: string): boolean {
  if (activeOnboardingId && activeOnboardingId !== id) {
    return false;
  }

  activeOnboardingId = id;

  return true;
}

export function releaseOnboarding(id: string): void {
  if (activeOnboardingId === id) {
    activeOnboardingId = null;
  }
}

export function resetOnboardingCoordinator(): void {
  activeOnboardingId = null;
}
